import { render } from "./IMSPage.vue?vue&type=template&id=6e1ca96c&scoped=true"
import script from "./IMSPage.vue?vue&type=script&lang=js"
export * from "./IMSPage.vue?vue&type=script&lang=js"

import "./IMSPage.vue?vue&type=style&index=0&id=6e1ca96c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1ca96c"]])

export default __exports__